import { render, staticRenderFns } from "./quickPayFooter.vue?vue&type=template&id=570afcd9"
import script from "./quickPayFooter.vue?vue&type=script&lang=js"
export * from "./quickPayFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports